// extracted by mini-css-extract-plugin
export default {"popover":"popover--TaEDr","divider":"divider--HK60N","paper":"paper--w0lhK","button":"button--UrJA7","primary":"primary--Mkpr6"};